exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".actionMenuSearchBox {\n  background-color: #3d4951 !important;\n  color: white;\n  height: 40px !important;\n  margin-top: 22px; }\n\n.whiteColor {\n  color: white !important; }\n\n.pointerCursor {\n  cursor: pointer; }\n\n.actionMenuFibreIcon {\n  width: 8px;\n  height: 8px; }\n\n.actionMenuMenu {\n  display: block !important;\n  padding: 0px !important;\n  min-width: 100%; }\n\n.custom-style-for-send {\n  -webkit-transform: rotate(-20deg);\n      -ms-transform: rotate(-20deg);\n          transform: rotate(-20deg); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/ActionMenu/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/ActionMenu/index.css
// module chunks = 504